'use client';

import React, { useEffect, useState } from "react";
import { getUserInfo, fetchFavorites } from "@/utils/useUserInfo";

type FavoritesRecord = Record<string, boolean>;

interface FavoritesProviderProps {
    children: (props: {
        userInfo: any;
        favorites: FavoritesRecord;
        setFavorites: React.Dispatch<React.SetStateAction<FavoritesRecord>>;
    }) => React.ReactNode;
}

/**
 * Client island that loads user info + favorites, then renders children via render prop.
 * Keeps the user-specific data fetching isolated from server components.
 */
const FavoritesProvider: React.FC<FavoritesProviderProps> = ({ children }) => {
    const [userInfo, setUserInfo] = useState<any>(null);
    const [favorites, setFavorites] = useState<FavoritesRecord>({});

    useEffect(() => {
        async function fetchUserData() {
            setUserInfo(await getUserInfo());
        }
        fetchUserData();
    }, []);

    useEffect(() => {
        async function fetchFavoritesData() {
            if (userInfo) {
                const favs = await fetchFavorites(userInfo?.cId);
                setFavorites(
                    favs.reduce(
                        (acc: any, id: any) => ({ ...acc, [id]: true }),
                        {} as FavoritesRecord
                    )
                );
            }
        }
        fetchFavoritesData();
    }, [userInfo]);

    return <>{children({ userInfo, favorites, setFavorites })}</>;
};

export default FavoritesProvider;
